import { createSlice, createAction } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import { Showroom, ShowroomQueryParams } from "../types";

interface ShowroomState {
	showroomList: Array<Showroom>;
	showroomDetail: Showroom;
	showroomTotal: number;
}

export const initialState: ShowroomState = {
	showroomList: [],
	showroomDetail: {
		id: 0,
		name: "",
		address: "",
		phoneNumber: "",
		image: "",
		manager: "",
		email: "",
		status: null,
	},
	showroomTotal: 0,
};

export const showroomSlice = createSlice({
	name: "showroom",
	initialState,
	reducers: {
		setListShowroom: (state, action) => {
			state.showroomList = action.payload.data;
			state.showroomTotal = action.payload.total;
		},
		setDetailShowroom: (state, action) => {
			state.showroomDetail = action.payload.data;
			// update list showrooms
			state.showroomList = state.showroomList.map(showroom => {
				if (showroom.id === action.payload.data.id) {
					showroom = action.payload.data;
				}
				return showroom;
			});
		},
		resetDetailShowroom: state => {
			state.showroomDetail = initialState.showroomDetail;
		},
	},
});

export const selectShowroomList = (state: RootState) =>
	state.showroom.showroomList;
export const selectShowroomTotal = (state: RootState) =>
	state.showroom.showroomTotal;
export const selectShowroomDetail = (state: RootState) =>
	state.showroom.showroomDetail;
export const { setListShowroom, setDetailShowroom, resetDetailShowroom } =
	showroomSlice.actions;

export interface GetListShowroomAsyncPayload {
	query: ShowroomQueryParams;
	callback?: () => void;
}

export const getListShowroomAsync = createAction(
	"showroom",
	(payload: GetListShowroomAsyncPayload) => ({
		payload,
	}),
);

export interface GetShowroomPayload {
	id: string;
	callback?: Function;
}

export const getShowroomAsync = createAction(
	"showroomDetail",
	(payload: GetShowroomPayload) => ({
		payload,
	}),
);

export interface UpdateShowroomPayload {
	id: string;
	showroom: Showroom;
	callback?: Function;
}

export const updateShowroomAsync = createAction(
	"updateShowroom",
	(payload: UpdateShowroomPayload) => ({ payload }),
);

export interface CreateShowroomPayload {
	showroom: Showroom;
	callback?: Function;
}

export const createShowroomAsync = createAction(
	"createShowroom",
	(payload: CreateShowroomPayload) => ({ payload }),
);

export default showroomSlice.reducer;
